import React from 'react'
import { Tooltip } from 'antd'
import _ from 'lodash'
import {
  InputWithPlaceHolder, ActionSelector, HeaderLabel, CellText,
} from '../../../components/start-point-components'

export default {
  columns: [{
    Header: () => <HeaderLabel>รหัส</HeaderLabel>,
    accessor: 'id',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.companyId, filter.value),
    width: 110,
  }, {
    Header: () => <HeaderLabel>ชื่อบริษัท</HeaderLabel>,
    accessor: 'name',
    Cell: props => <Tooltip placement="top" title={props.value}><CellText>{props.value}</CellText></Tooltip>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.createdDate, filter.value),
    sortable: false,
    filterable: true,
    width: 300,
  }, {
    Header: <HeaderLabel>สาขา</HeaderLabel>,
    accessor: 'branch',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{_.isNull(props.value) || _.isEmpty(props.value) ? 'ไม่ระบุ' : props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.clientName, filter.value),
    width: 140,
  }, {
    Header: <HeaderLabel>ที่อยู่</HeaderLabel>,
    accessor: 'address',
    sortable: false,
    filterable: true,
    Cell: props => <CellText>{_.isNull(props.value) ? 'ไม่ระบุ' : props.value}</CellText>,
    Filter: ({ onChange }) => <InputWithPlaceHolder handleChange={e => onChange(e)}/>,
    filterMethod: (filter, row) => _.includes(row.from, filter.value),
    width: 160,
  }, {
    Header: <HeaderLabel>เลขที่เสียภาษี</HeaderLabel>,
    accessor: 'taxId',
    sortable: false,
    filterable: false,
    Cell: props => <CellText>{props.value}</CellText>,
    width: 160,
  }, {
    Header: null,
    accessor: 'action',
    sortable: false,
    filterable: false,
    // Cell: props => <ActionSelector disabled={props.tdProps.rest.disabled} />,
    Cell: props => <ActionSelector props={props} />,
    width: 150,
  }],
}
